export const formatDate = (input: Date, format = 'yyyy-mm-dd'): string => {
  const yyyy = input.getFullYear().toString().padStart(4, '0')
  const mm = (input.getMonth() + 1).toString().padStart(2, '0')
  const dd = input.getDate().toString().padStart(2, '0')

  if (format !== 'yyyy-mm-dd') throw new Error('invalid date format')
  return (yyyy + '-' + mm + '-' + dd).toString()
}

export const dateDiffWordsDays = (diff: number) => {
  // TODO: use locale names
  switch (diff) {
    case 0:
      return 'today'
    case 1:
      return 'tomorrow'
    case -1:
      return 'yesterday'
    default:
      if (diff < 0) return `${diff * -1} days ago`
      return `in ${diff} days`
  }
}

export const getYear = (date: string) => Number(date.substr(0, 4))
export const getMonth = (date: string) => Number(date.substr(5, 2))
export const getDay = (date: string) => Number(date.substr(8, 2))
export const getUtcDate = (date: string): Date =>
  new Date(Date.UTC(getYear(date), getMonth(date) - 1, getDay(date)))
